import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import toastr from "toastr"
import i18n from "i18n"
import { API } from "api"
import { removeStaticPage } from "./slice"

function* remove({ payload: { id } }) {
  try {
    const response = yield call(API.admin.removeStaticPage, id)

    const { data } = response

    yield put(removeStaticPage.removeCompleted())

    toastr.success(i18n.t("remove.success"))
  } catch (error) {
    const errors = error.response?.data?.errors || {}
    const message = error.response?.data?.message || i18n.t("error")

    yield put(
      removeStaticPage.removeRejected({
        errors,
        message,
      })
    )
    toastr.error(message)
  }
}

export function* watchRemove() {
  yield takeEvery(removeStaticPage.remove, remove)
}

function* removeSaga() {
  yield all([fork(watchRemove)])
}

export default removeSaga
